export default "__VITE_ASSET__DZiHOnj6__"